export default __webpack_public_path__ + "static/media/grafana-svgrepo-com.101ac97a.svg";